import React, { FC } from 'react';
import { getProductionBatchByProductionOperationId, operationsSearch } from '@reducers/search';
import { updateHeaderConfig } from '@reducers/details';
import { connect } from 'react-redux';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { useJobDetails } from '@v2/pages/common/hooks/useJobDetails';
import { getNCFilesByProductionOperationId } from '@reducers/manufacture';
import { DOCUMENT_ENTITY_TYPE } from '@components/imageHandling/common';
import { ImagesDocumentsContent } from '@v2/pages/nc-file/details/modules/nc-file/components/ImagesDocumentsContent';
import JobContentWrapper from '@v2/pages/job/common/components/JobContentWrapper';
import { View } from 'react-native';
import { DETAILS_DOCUMENTS_SCREENS_CONTAINER_STYLES } from '@v2/pages/common/constants/base.constants';

interface JobDetailsPartDocumentsProps {
  partId: number | null;
}

const JobDetailsPartDocumentsComponent: FC<JobDetailsPartDocumentsProps> = ({
  updateHeaderConfig,
  operationsSearch,
  getNCFilesByProductionOperationId,
  getProductionBatchByProductionOperationId,
  partId,
}) => {
  const title = useTitle();

  useJobDetails({
    operationsSearch,
    updateHeaderConfig,
    getNCFilesByProductionOperationId,
    getProductionBatchByProductionOperationId,
  });

  return (
    <JobContentWrapper loading={false} title={title.part}>
      {partId != null && (
        <View style={DETAILS_DOCUMENTS_SCREENS_CONTAINER_STYLES}>
          <ImagesDocumentsContent documentRetrieveId={partId} documentRetrieveKey={DOCUMENT_ENTITY_TYPE.Part} />
        </View>
      )}
    </JobContentWrapper>
  );
};

const JobDetailsPartDocuments = connect(({ details: { partId } }) => ({ partId }), {
  updateHeaderConfig,
  operationsSearch,
  getNCFilesByProductionOperationId,
  getProductionBatchByProductionOperationId,
})(JobDetailsPartDocumentsComponent);

export { JobDetailsPartDocuments };
